<section>
    <article>
        <div class="mrt-75">
            <div class="main-action-col" style="padding: 5px 0px;">
                <div style="padding-left: 15px; padding-right: 15px; margin-left: auto; margin-right: auto;">
                    <div class="row">
                        <div class="d-flex align-items-center responsive">
                            <div style="padding: 0px 10px;    max-width:150px;">
                                <div class="" *ngIf="roundedTemp">
                                    <div class="" *ngIf="showWeatherDiv">
                                        <img class="img-fluid imag_width" alt="" [src]='icons_display'>
                                        <span class="temp">{{roundedTemp}}</span>
                                    </div>
                                    <h5 class="fw-semibold text-secondary mt-15"> {{city_weather}} , {{state_weather}}
                                    </h5>
                                </div>
                            </div>
                            <div id="status_box">
                                <div class="status_heading">
                                    <h2 class="title pr-2 mb-0" style="line-height: 25px;">
                                        <span class="solar_img" *ngIf="site.solarState==true">
                                            <img src="../../../../assets/imgs/solar-panels.png"
                                                style="width:35px;height:35px;"></span>{{site.siteName}}
                                    </h2>
                                </div>
                                <div class="status_box" *ngIf="!oppotunityStageMessage">
                                    <span class="nbadge paused-status text-light p-2" *ngIf="site.installedStatus == 'Pause Service'">Paused</span>                                    <span class="nbadge up-status text-light p-2"
                                        *ngIf="site.status && site.status.toLowerCase() == 'up' && site.installedStatus !== 'Pause Service'">{{site.status}}</span>
                                    <span class="nbadge down-status text-light p-2"
                                        *ngIf="site.status && site.status.toLowerCase() == 'down' && site.installedStatus !== 'Pause Service'">{{site.status}}</span>
                                    <span class="nbadge partial-status text-light p-2"
                                        *ngIf="site.status && site.status.toLowerCase() == 'partialdown' && site.installedStatus !== 'Pause Service'">{{site.status ?'PSD': ' ' + ' '}}</span>
                                    <span style="padding: 0px 10px; color:#f16e02"
                                        *ngIf="site.status && site.status.toLowerCase() == 'partialdown' && site.installedStatus !== 'Pause Service'">{{percentageDownDevice | percent }} Devices down</span>
                                </div>
                            </div>
                            <div *ngIf="hdOrSd" class="hdOrSd">
                                <span [innerText]="hdOrSd + ' to monitoring'"></span>
                                <br>
                            </div>
                            <div class="timeZone">
                                {{site.timeZone}}
                            </div>
                            <div class="table_status" *ngIf="!oppotunityStageMessage">

                                <table class="tableWidth">
                                    <thead>
                                        <tr>
                                            <th class="text-center">Devices</th>
                                            <th class="text-center">Total</th>
                                            <th class="text-center">Up</th>
                                            <th class="text-center">Down</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">Cams</td>
                                            <td class="text-center">{{camCount}}</td>
                                            <td class="text-center">{{camUpCount}}<i class="fa fa-arrow-up iconArrow icon_up"></i></td>
                                            <td class="text-center">{{camDownCount}}<i class="fa fa-arrow-down iconArrow icon_down"></i>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Alarms</td>
                                            <td class="text-center">{{AlarmCount}}</td>
                                            <td class="text-center">{{alarmUpCount}}<i class="fa fa-arrow-up iconArrow icon_up"></i></td>
                                            <td class="text-center">{{alarmDownCount}}<i class="fa fa-arrow-down iconArrow icon_down"></i>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Others</td>
                                            <td class="text-center">{{otherCount}}</td>
                                            <td class="text-center">{{otherUpCount}}<i class="fa fa-arrow-up iconArrow icon_up"></i></td>
                                            <td class="text-center">{{otherDownCount}}<i class="fa fa-arrow-down iconArrow icon_down"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table_status" *ngIf="oppotunityStageMessage">

                                <table class="tableWidth">
                                    <thead>
                                        <tr>
                                            <th class="text-center">Devices</th>
                                            <th class="text-center">Total</th>
                                            <th class="text-center">Up</th>
                                            <th class="text-center">Down</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">Cams</td>
                                            <td class="text-center">{{camCount}}</td>
                                            <td class="text-center">-</td>
                                            <td class="text-center">-</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Alarms</td>
                                            <td class="text-center">{{AlarmCount}}</td>
                                            <td class="text-center">-</td>
                                            <td class="text-center">-</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Others</td>
                                            <td class="text-center">{{otherCount}}</td>
                                            <td class="text-center">-</td>
                                            <td class="text-center">-</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                        <div class="col-sm-7">
                            <div class="cam-pagination-listsImg">
                                <div class="innerRightActions">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style=" margin-top: 1rem;flex: 1 1 auto; position: relative;">
                <div class="d-flex align-items-center justify-content-end sdt-cal pdng">
                    <span  style="position: absolute; left: 0;padding-left: 10px;" class="sync">
                        <a *ngIf="site.siteInfoLink  && site.siteInfoLink  !== 'n/a' && site.siteInfoLink  !== '-'" [attr.href]="site.siteInfoLink" target="_blank">
                            <span style="font-size: 16px;font-family:Roboto;padding-right: 20px;">Site Documentation Link</span>
                        </a>
                        <span *ngIf="site.installedStatus == 'Pause Service'">
                            <span class="msg">(All health Monitoring is stopped as the service is Paused)</span>
                        </span>        
                    </span>
                    <div>
                        <button mat-stroked-button [disabled]="buttonDisabled" class="sync" (click)="sync()" *ngIf="this.site.serverUrl.indexOf('8443/pro-vigil') >=0">
                            <i class="fas fa-sync" style="font-size: 18px;"></i>
                        </button>
                    </div>   

                    <mat-form-field class="me-2" appearance="fill" *ngIf="isFilter">
                        <mat-label>Filter </mat-label>
                        <mat-select name="filter" [(value)]="filterValue" id="filter" (selectionChange)="daysFilter()" [(ngModel)]="filterValue">
                            <mat-option value=1>1Day</mat-option>
                            <mat-option value=7>7Days</mat-option>
                            <mat-option value=14>14Days</mat-option>
                            <mat-option value=30>30Days</mat-option>
                            <mat-option value="custom">Custom</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="me-2" *ngIf="filterValue=='custom' && isFilter">
                        <input matInput readonly [ngxMatDatetimePicker]="picker" placeholder="From" [(ngModel)]="start"
                            [disabled]="disabled" (dateChange)="daysFilter()" class="form-control bgNone"
                            autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
                        <owl-date-time #picker>
                        </owl-date-time>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="me-2" *ngIf="filterValue=='custom' && isFilter">
                        <input matInput readonly [ngxMatDatetimePicker]="picker1"   placeholder="To"[(ngModel)]="end" autocomplete="off"
                            class="form-control bgNone" (dateChange)="daysFilter()">
                        <mat-datepicker-toggle matSuffix [for]="$any(picker1)"></mat-datepicker-toggle>
                        <owl-date-time #picker1>
                        </owl-date-time>
                    </mat-form-field>
                </div>

                <div class="oppotunityStageMessage" *ngIf="oppotunityStageMessage">
                    <span>{{oppotunityStageMessage}}</span>
                </div>

                <mat-tab-group #tabGroup mat-stretch-tabs class="tabGroup"
                    (selectedTabChange)="selectedTabValue($event)">
                    <mat-tab label="Site Dashboard">
                        <mat-tab-group #siteTabGroup mat-stretch-tabs class="siteTabGroup"
                            (selectedTabChange)="siteTabSelected($event)">
                            <mat-tab label="Status">
                                <div style="margin-bottom: 2%;" *ngIf="!oppotunityStageMessage">
                                    <iframe id="ifr" src="" width="100%" height=200 frameborder="1">
                                    </iframe>
                                </div>
                                <div class="oppotunityStageMessage performance_dashboard" *ngIf="oppotunityStageMessage">
                                    <span class="headingCenter">{{oppotunityStageMessage}}</span>
                                </div>
                            </mat-tab>
                            <mat-tab label="Performance Dashboard">
                                <div class="oppotunityStageMessage performance_dashboard" *ngIf="oppotunityStageMessage">
                                    <span class="headingCenter">{{oppotunityStageMessage}}</span>
                                </div>
                                <div *ngIf="!oppotunityStageMessage">
                                    <app-performance-dashboard [siteFromDate]="fromDate" [siteToDate]="toDate" [siteUnitId]="siteId" [siteAccName]="accName" *ngIf="isperformanceEnabled"></app-performance-dashboard>
                                </div>
                            </mat-tab>
                            <mat-tab label="Monitoring Hours">
                                <div class="w-100 t-history table-container" style="padding-bottom: 20px;">
                                    <table class="table" style="width: 100%;">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">Day</span>
                                                    </div>
                                                </th>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">24 Hours</span>
                                                    </div>
                                                </th>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">Morning Start to End Time</span>
                                                    </div>
                                                </th>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">Evening Start to End Time</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="results && results.length; else noData">
                                            <tr *ngFor="let data of results; let i = index;">
                                                <td class="text-center">{{data.weekDay ? data.weekDay : 'N/A'}}</td>
                                                <td class="text-center">{{data.twenty4Hrs ? data.twenty4Hrs : 'N/A'}}</td>
                                                <td class="text-center">{{data.result[0]?.MonitoringHours ? data.result[0]?.MonitoringHours.split(' AM').join('').split(' PM').join('') : 'N/A'}}</td>
                                                <td class="text-center">{{data.result[1]?.MonitoringHours ? data.result[1]?.MonitoringHours.split(' AM').join('').split(' PM').join('') : 'N/A'}}</td>
                                            </tr>
                                        </tbody>
                                        <ng-template #noData>
                                            <tbody>
                                                <tr class="no-data-row">
                                                    <td colspan="4" class="text-center no-data-cell"><b>NO DATA AVAILABLE</b></td>
                                                </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </mat-tab>                            
                            <mat-tab label="Stats Metrics">
                                <iframe id="ifrcpu" src="" width="100%" height=350 frameborder="1">
                                </iframe>
                            </mat-tab>
                            <mat-tab label="Weather">
                               <div class="forecast-header">
                                Forecast-daily
                              </div>
                                <div class="container">
                                <div class="sub-container">
                                <div class="forecast-container">
                                    <div *ngFor="let weather of forcastDays;let i=index" class="forecast-box">
                                        <div class="forecast-date">{{forcastDays[i]}}</div>
                                        <div class="forecast-temp">{{forcastTemp[i]}}<span class="degree-symbol">°F</span></div>
                                        </div>
                                </div>
                                
                                <div class="weather-indicators">
                                    <div class="tembox">
                                        <span class="title">Rain</span>
                                        <div class="rain-section" *ngIf="rainData=='Rain'">{{rainData}}</div>
                                        <div class="rain-section" *ngIf="rainData!=='Rain'">No Rain</div>
                                    </div>
                                    <div class="tembox">
                                        <span class="title">Temperature</span>
                                        <div class="temperature-section">{{temperature}}<span class="font">°F</span>                                 
                                        </div>
                                    </div>
                                    </div>
                                </div>
                         </div>
                            </mat-tab>
                            <mat-tab label="Tickets History (Last 90 days)">
                                <div class="w-100 t-history">
                                    <table class="table" style="width: 100%;" style="margin-bottom: 30px;">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">Ticket
                                                            ID</span>
                                                    </div>
                                                </th>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">Status
                                                        </span>
                                                    </div>
                                                </th>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">Created
                                                            Date</span>
                                                    </div>
                                                </th>
                                                <th scope="col" class="sticky-header">
                                                    <div class="d-flex align-items-center">
                                                        <span style="text-align: center;margin: auto;">View
                                                            Ticket</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="thistoryData && thistoryData.length; else noData1">
                                            <tr *ngFor="let data of thistoryData; let i = index;">
                                                    <td class="text-center" style="cursor: pointer;" (click)="showPopup(data.deviceNames,data.ticketsDeviceStatus,data.ticketId,data.ticketLink)"><u style="color: blue;">{{data.ticketId}}</u></td>
                                                    <td class="text-center">{{data.ticketStatus ? data.ticketStatus : 'N/A'}}</td>
                                                    <td class="text-center">{{data.createDate ? data.createDate : 'N/A'}}</td>
                                                    <td class="text-center"><a [attr.href]="data.ticketLink" target="_blank">Click here</a></td>    
                                            </tr>
                                        </tbody>
                                        <div *ngIf="popupVisible" class="popup-backdrop">
                                            <div class="popup">
                                                <div class="d-flex p-0 bg-clr">
                                                    <span><h3>Ticket Status <span>(<a [attr.href]="ticketLink" target="_blank">{{ticket}}</a>)</span></h3></span>
                                                    <span><button mat-button color="warn" (click)="hidePopup()" class="close">X</button></span>
                                                </div>
                                                <table class="popup-table">
                                                    <thead>
                                                        <tr>
                                                            <th class="popup-header">Device Name</th>
                                                            <th class="popup-header">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let device of deviceNames; let i = index">
                                                            <td class="popup-cell">{{ device }}</td>
                                                            <td class="popup-cell">{{ deviceStatus[i] }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <ng-template #noData1>
                                            <tbody>
                                                <tr class="no-data-row" *ngIf="!loading">
                                                    <td colspan="5" class="text-center no-data-cell"><b>NO DATA AVAILABLE</b></td>
                                                </tr>
                                                <tr class="no-data-row" *ngIf="loading">
                                                    <td colspan="5" class="text-center no-data-cell"><b>Loading...</b></td>
                                                </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-tab>

                    <mat-tab label="Devices">
                        <div style="flex-wrap: row; display: box; width: 100%;margin-bottom: 2%;" *ngIf="!oppotunityStageMessage">
                            <div *ngFor="let cam of cams">
                                <div style="text-align: center;font-weight: bold;margin-top: 22px;">{{cam.deviceName}}</div>
                                <iframe [id]="cam.deviceId" src="" width="100%" height="200" frameborder="1">
                                </iframe>
                            </div>
                        </div>
                        <div class="oppotunityStageMessage performance_dashboard" *ngIf="oppotunityStageMessage">
                            <span class="headingCenter">{{oppotunityStageMessage}}</span>
                        </div>
                    </mat-tab>
                    <mat-tab label="Devices Info">
                        <div style="padding-bottom: 20px;">
                            <table class="table table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('deviceUqId')">
                                                <span style="text-align: center;margin: auto;">Device UniqueID</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('port')">
                                                <span style="text-align: center;margin: auto;">Port</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('potentialId')">
                                                <span style="text-align: center;margin: auto;">Potential ID</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('vpnIp')">
                                                <span style="text-align: center;margin: auto;">Device IP</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('deviceType')">
                                                <span style="text-align: center;margin: auto;">Device Type</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('deviceName')">
                                                <span style="text-align: center;margin: auto;">Device Name</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('status')">
                                                <span style="text-align: center;margin: auto;">Status</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('type')">
                                                <span style="text-align: center;margin: auto;">Type</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('statusDuration')">
                                                <span style="text-align: center;margin: auto;">Status Duration</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                        <th scope="col" class="sticky-header">
                                            <div class="d-flex align-items-center justify-content-center" 
                                                (click)="sortItems1('message')">
                                                <span style="text-align: center;margin: auto;">Message</span>
                                                <span class="pl-2">
                                                    <div class="arrow-section"><i class="arrow up"></i></div>
                                                    <div class="arrow-section"><i class="arrow down"></i></div>
                                                </span>    
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="site.devices !== undefined && site.devices !== null && site.devices.length > 0">
                                    <tr *ngFor="let siteData of site.devices">
                                        <td style="text-align: center;">{{siteData.deviceUqId || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.port || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.potentialId || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.vpnIp || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.deviceType || 'N/A'}}</td>
                                        <td *ngIf="siteData.deviceType=='Camera'" class="camAlign">
                                            <span (click)="showModal(siteData)" class="model">
                                                <i style="height: 25px; width: 25px; text-align: center; float: left;"
                                                    data-toggle="modal" data-target="#exampleModal" class="fa fa-image"
                                                    style="font-size:18px; color:grey"></i>
                                            </span>
                                            <span (click)="showCameraData(siteData?.deviceUqId)" class="highlightMeta">{{siteData.deviceName || 'N/A'}}</span>
                                        </td>
                                        <td  *ngIf="siteData.type =='Router'">
                                            <span (click)="showRouterdata(siteData)">
                                                <span class="highlightMeta">
                                                    {{siteData.deviceName || 'N/A'}}
                                                </span>
                                            </span>
                                        </td>
                                        <td *ngIf="siteData.type =='Odroid'">
                                            <span (click)="showMdcdata(siteData)">
                                                <span class="highlightMeta">
                                                    {{siteData.deviceName || 'N/A'}}
                                                </span>
                                            </span>
                                        </td>
                                        <td *ngIf="siteData.deviceType !== 'Camera' && siteData.type !== 'Odroid' && siteData.type !== 'Router'">
                                            <span>{{ siteData.deviceName || 'N/A' }}</span>
                                        </td>
                                        <td style="text-align: center;">{{siteData.status || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.type || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.statusDuration || 'N/A'}}</td>
                                        <td style="text-align: center;">{{siteData.message || 'N/A'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-tab>
                    <mat-tab label="Network Topology">
                        <div *ngIf="networkData == null" class="noData">
                            <b>NO DATA AVAILABLE</b>
                        </div>
                        <div *ngIf="networkData">
                            <div class="fullDiv">
                                <button id="toggleId" style="position: fixed;margin-left: 10px">
                                    <i class="fa fa-expand"></i>
                                </button>
                            </div>
                            <div id="toggle" style="overflow: auto; background-color: white;">
                                <div class="btn-label">
                                    <button mat-button (click)="zoomToggle(true)"><i class="fa fa-plus"
                                            aria-hidden="true"></i></button>
                                    <button mat-button (click)="zoomToggle(false)"><i class="fa fa-minus"
                                            aria-hidden="true"></i></button>
                                </div>
                                <div class="legend">
                                    <p style="text-align: center;"><b><u>Legend</u></b></p>
                                    <img src="./assets/imgs/Aetek-Switch.png" class="legend-img">
                                    <p
                                        class="legend-data">
                                        - Switch</p><br>
                                    <img src="./assets/imgs/AXIS-M2025-LE-Network-Camera.png" class="legend-img">
                                    <p
                                        class="legend-data">
                                        - Camera</p><br>
                                    <img src="./assets/imgs/AXIS-C3003-E-Network-Horn-Speaker.png" class="legend-img">
                                    <p
                                    class="legend-data">
                                        - Alarm</p><br>
                                    <img src="./assets/imgs/Wireless-Access-Point.png" class="legend-img">
                                    <p
                                    class="legend-data">
                                        - AP/CB</p><br>
                                    <img src="./assets/imgs/cradlepoint-router.png" class="legend-img">
                                    <p
                                    class="legend-data">
                                        - Cradlepoint-Router</p><br>
                                    <img src="./assets/imgs/question.png" class="legend-img">
                                    <p
                                    class="legend-data">
                                        - Unmanaged device</p><br>
                                    <img src="./assets/imgs/cancel.png" class="legend-img">
                                    <p
                                        class="legend-data">
                                        - Not Connected</p><br>
                                    <p style="display: inline;font-size: 20px;margin-left: 9px">+</p>
                                    <p
                                        style="display: inline; font-style: normal; font-family: FontAwesome; font-weight: normal;padding-left: 4px;">
                                        - More Info</p><br>
                                </div>
                                <div id="myChart" #chartContainer>
                                    <div id="displayBox">
                                    </div>
                                    <div id="toaster-container" class="toaster-container"></div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Network Devices">
                        <!-- <div *ngIf="!noData"> -->
                            <table class="networkDevice" id="network" class="sortable" style="margin-bottom: 2%;">
                                <tr>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('deviceName')">
                                            <span>Name</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('model')">
                                            <span>Model</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('deviceUqId')">
                                            <span>Unique Id</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('device_type')">
                                            <span>Type</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('ip_address')">
                                            <span>Pvt Ip</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('snmp_enabled')">
                                            <span>Snmp Enabled</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('snmp_version')">
                                            <span>Snmp Version</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('tunnel_forwarding_port')">
                                            <span>Vpn Port</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('tunnel_ip')">
                                            <span>Vpn Ip</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('username')">
                                            <span>Username</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="sticky-header">
                                        <div class="d-flex align-items-center justify-content-center"
                                            (click)="sortItems('firmware')">
                                            <span>Firmware Version</span>
                                            <span class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                                <tr *ngFor="let scan of networkData" class="item" style="text-align: center;">
                                    <ng-container
                                        *ngIf="scan.snmp_version!=null || scan.changed_status!='DISCONNECTED'">
                                        <td>{{scan.deviceName || 'N/A'}}</td>
                                        <td>{{scan.model || 'N/A'}}</td>
                                        <td>{{scan.deviceUqId || 'N/A'}}</td>
                                        <td>{{scan.device_type || 'N/A'}}</td>
                                        <td>{{scan.ip_address || 'N/A'}}</td>
                                        <td>{{scan.snmp_enabled || 'N/A'}}</td>
                                        <td>{{scan.snmp_version || 'N/A'}}</td>
                                        <td>{{scan.tunnel_forwarding_port || 'N/A'}}</td>
                                        <td>{{scan.tunnel_ip || 'N/A'}}</td>
                                        <td>{{scan.username || 'N/A'}}</td>
                                        <td>{{scan.firmware || 'N/A'}}</td>
                                    </ng-container>
                                </tr>
                            </table>
                            <div *ngIf="networkData == null" class="noData">
                                <b>NO DATA AVAILABLE</b>
                            </div>
                    </mat-tab>
                    <mat-tab label="Solar Script" *ngIf="site.unitType=='Mobile' && site.powerSource.toLowerCase().includes('solar')">
                        <mat-tab-group>
                            <mat-tab label="View Solar Script" (click)="selectTab(1)" class="view-solar">
                                <ng-template #scriptTemplate>
                                    <div class="text-center">
                                        <div class="lastChange" *ngIf="lastModifiedBy">
                                            <span class="createBy">Last Modified by</span> | <span class="createBy font-wgt">{{ lastModifiedBy ? (lastModifiedBy === 'Auto job' ? 'None': lastModifiedBy) : 'Data Not Found'}}</span>
                                        </div>
                                        <div class="lastChange" *ngIf="lastModifiedAt">
                                            <span class="createBy">Last Modified Date</span> | <span class="createBy font-wgt">{{lastModifiedAt ? formatdate(lastModifiedAt) : 'Data Not Found'}} (UTC)</span>
                                        </div>
                                        <div class="lastChange width-20" *ngIf="lastModifiedAt">
                                            <span class="createBy">Source</span> | <span class="createBy font-wgt">{{ source?.toUpperCase() === 'DATABASE' ? 'Pro-Fit DB' : (source?.toUpperCase() === 'DEVICE' ? devicetype == undefined?'MDC Device':devicetype + ' Device' : source ?? 'Data Not Found')}}</span>
                                        </div>
                                    </div>
                                    
                                    <div class="summary-container" *ngIf="(devicetype == 'X310' || devicetype == 'X410') && startDays != undefined">
                                        <h4 class="heading"><u><span class="overview">Solar Script Overview</span></u></h4>
                                        <div class="mg">
                                            <div class="data-item">
                                                <span class="days">Days :</span>
                                                <span class="value ml">{{ startDays }} to {{ endDays }}</span>
                                            </div>
                                            <div class="data-item">
                                                <span class="timings">Timings :</span>
                                                <span class="value ml5">{{ startTimes }} to {{ endTimes }}</span>
                                            </div>
                                        </div>
                                    </div>
                                      
                                    <div *ngIf="mdcScript1 && !responseData">
                                        <div class="script">
                                            <pre>{{ mdcScript1 | json }}</pre>
                                        </div>
                                    </div>
                        
                                    <div *ngIf="responseData && !mdcScript1">
                                        <div class="script">
                                            <pre style="padding-bottom: 25px;">{{ responseData }}</pre>
                                        </div>
                                    </div>
                        
                                    <div class="no-script" *ngIf="!responseData && !mdcScript1">
                                        <span>SCRIPT NOT AVAILABLE</span>
                                    </div>
                                </ng-template>
                        
                                <ng-template #updateTemplate>
                                    <div class="d-flex script1">
                                        <div class="w-100 m-auto">
                                            <div class="time-field">
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="label">SOLAR SCRIPT START TIME</mat-label>
                                                    <input class="start-end-Time" type="time" required
                                                        [(ngModel)]="preStartTime" name="preStartTime" #startTimeRef="ngModel" (change)="timesChanged(preStartTime, preEndTime)" matInput/>
                                                        <div class="hours">HH : MM</div>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="label">SOLAR SCRIPT END TIME</mat-label>
                                                    <input class="start-end-Time" type="time" required
                                                        [(ngModel)]="preEndTime" name="preEndTime" #endTimeRef="ngModel" (change)="timesChanged(preStartTime, preEndTime)" matInput/>
                                                        <div class="hours">HH : MM</div>
                                                </mat-form-field>
                                            </div>
                                            <div class="time-error">
                                                <span *ngIf="(preStartTime && preEndTime) && timesNotValid()"></span>
                                                <span *ngIf="!preStartTime && !preEndTime" class="text-red">Please select Solar script start time and end time</span>
                                                <span *ngIf="!preStartTime && preEndTime" class="text-red">Please select Solar script start time</span>
                                                <span *ngIf="preStartTime && !preEndTime" class="text-red">Please select Solar script end time</span>
                                            </div>
                                            <div style="width: auto;" class="d-flex justify-content-center">
                                            <div class="parent-container">  
                                              <div class="dropdown-container">
                                                <mat-form-field class="select-input-field" appearance="outline">
                                                    <mat-label class="label">CHECK DAYS</mat-label>
                                                    <mat-select placeholder="Check days" [(ngModel)]="precheckDay"
                                                        name="precheckDay" style="font-size: large;font-weight: 500" (selectionChange)="checkChange($event.value)" matInput>
                                                        <mat-option [value]="" disabled style="color: black;">Select Check days</mat-option>
                                                        <mat-option *ngFor="let inspectionType of inspectionTypes"
                                                            [value]="inspectionType.description">
                                                            {{inspectionType.description}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="checkday-error">
                                                <span *ngIf="!precheckDay" style="margin-left: 10px;">Please select check days</span>
                                            </div>
                                                <div *ngIf="!basicCheck()" class="radio-container">
                                                    <div style="text-align: right;">
                                                    <mat-checkbox 
                                                    [class.custom-checked]="isChecked" 
                                                    (change)="checkboxToggled($event)" 
                                                    [(ngModel)]="delayFlag">
                                                     ADD 2 HOUR DELAY
                                                    </mat-checkbox>
                                                </div>
                                            </div>  
                                          </div>                                        
                                            </div>
                                            <span *ngIf="!basicCheck()" class="note"><b>* NOTE : </b>When 2 hour delay check box is checked, device will be ON for 2 hours after the power is restored and then solar script schedule is followed.</span>
                                        </div>
                                    </div>
                                </ng-template>

                                <ng-template #updateTemplateMDC>
                                    <div class="d-flex script1">
                                        <div class="w-100 m-auto">
                                            <table class="schedule-table">
                                                <thead>
                                                    <tr>
                                                        <th class="schedule-font">Day</th>
                                                        <th class="schedule-font">Morning Start to End Time</th>
                                                        <th class="schedule-font">Evening Start to End Time</th>
                                                        <th class="schedule-font">24 Hour</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="mdcScript1">
                                                    <tr *ngFor="let day of orderedDays">
                                                        <td><h1 class="day-name">{{day | titlecase}}</h1></td>
                                                        
                                                        <td>
                                                            <div class="time-group center-content">
                                                                <input type="time" class="start-end-Time"
                                                                       *ngIf="mdc_preData[day?.toLowerCase()]"
                                                                       [ngModel]="mdc_preData[day?.toLowerCase()][0].monitoringStart"
                                                                       (ngModelChange)="mdc_preData[day?.toLowerCase()][0].monitoringStart = $event;"
                                                                       name="{{day}}MorningStart" class="time-input"
                                                                       [disabled]="checkbox24hr.checked"/>
                                                                -
                                                                <input type="time" class="start-end-Time"
                                                                       *ngIf="mdc_preData[day?.toLowerCase()]"
                                                                       [ngModel]="getMonitoringEnd(day)"
                                                                       (ngModelChange)="mdc_preData[day?.toLowerCase()][0].monitoringEnd = $event;"
                                                                       name="{{day}}MorningEnd" class="time-input"
                                                                       [disabled]="checkbox24hr.checked"/>
                                                            </div>
                                                        </td>
                                                        
                                                        <td>
                                                            <div class="time-group">
                                                                <input type="time" class="start-end-Time"
                                                                       *ngIf="mdc_preData[day?.toLowerCase()]"
                                                                       [ngModel]="getMonitoringStart(day)"
                                                                       (ngModelChange)="setMonitoringData(day, 'start', $event);"
                                                                       name="{{day}}EveningStart" class="time-input"
                                                                       [disabled]="checkbox24hr.checked"/>
                                                                -
                                                                <input type="time" class="start-end-Time"
                                                                       *ngIf="mdc_preData[day?.toLowerCase()]"
                                                                       [ngModel]="getMonitoringEndForSecond(day)"
                                                                       (ngModelChange)="setMonitoringData(day, 'end', $event);"
                                                                       name="{{day}}EveningEnd" class="time-input"
                                                                       [disabled]="checkbox24hr.checked"/>
                                                            </div>
                                                        </td>
                                                        
                                                        <td>
                                                            <mat-checkbox [checked]="is24HrChecked(day)" (change)="toggle24Hr(day, $event)" #checkbox24hr>
                                                            </mat-checkbox>
                                                        </td>
                                                    </tr>
                                                </tbody>                                        
                                                <tbody *ngIf="!mdcScript1">
                                                    <tr *ngFor="let day of orderedDays">
                                                        <td><h1 class="day-name">{{day | titlecase}}</h1></td>
                                                        <td>
                                                            <div class="time-group">
                                                                <input type="time" class="start-end-Time" name="{{day}}MorningStart" class="time-input" [(ngModel)]="inputTimes[day].morningStart" [disabled]="checkbox24hrs.checked"/>
                                                                    -
                                                                <input type="time" class="start-end-Time" name="{{day}}MorningEnd" class="time-input" [(ngModel)]="inputTimes[day].morningEnd" [disabled]="checkbox24hrs.checked"/>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="time-group">
                                                                <input type="time" class="start-end-Time" name="{{day}}EveningStart" class="time-input" [(ngModel)]="inputTimes[day].eveningStart" [disabled]="checkbox24hrs.checked"/>
                                                                    -
                                                                <input type="time" class="start-end-Time" name="{{day}}EveningEnd" class="time-input" [(ngModel)]="inputTimes[day].eveningEnd" [disabled]="checkbox24hrs.checked"/>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <mat-checkbox [(ngModel)]="checkboxStates[day]" (change)="on24HrCheckboxChange($event.checked, day); toggle24Hr(day, $event)" #checkbox24hrs>
                                                            </mat-checkbox>                                               
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                 </ng-template>        
                        
                                <ng-template #previewTemplate>
                                    <div class="script">
                                        <div *ngIf="(previewResponse$ | async) as response">
                                            <pre>{{ response }}</pre>
                                        </div>
                                    </div>
                                </ng-template>

                                <ng-template #previewMDCTemplate>
                                    <div class="script">
                                        <div>
                                            <pre>{{previewMDCresponse | json}}</pre>
                                        </div>
                                    </div>
                                </ng-template>

                                <ng-template #basicScriptTemplate>
                                    <div class="text-center">
                                        <div class="lastChange" *ngIf="lastModifiedBy">
                                            <span class="createBy">Last Modified by</span> | <span class="createBy font-wgt">{{ lastModifiedBy ? (lastModifiedBy === 'Auto job' ? 'None': lastModifiedBy) : 'Not Found'}}</span>
                                        </div>
                                        <div class="lastChange" *ngIf="lastModifiedAt">
                                            <span class="createBy">Last Modified Date</span> | <span class="createBy font-wgt">{{lastModifiedAt ? formatdate(lastModifiedAt) : 'Not Found'}} (UTC)</span>
                                        </div>
                                        <div class="lastChange width-20" *ngIf="lastModifiedAt">
                                            <span class="createBy">Source</span> | <span class="createBy font-wgt">{{ source?.toUpperCase() === 'DATABASE' ? 'Pro-Fit DB' : (source?.toUpperCase() === 'DEVICE' ? devicetype + ' Device' : source ?? 'Not Found')}}</span>
                                        </div>
                                    </div>
                                           
                                    <div *ngIf="mdcScript1 && !responseData">
                                        <div class="script">
                                            <pre>{{ mdcScript1 | json }}</pre>
                                        </div>
                                    </div>
                        
                                    <div *ngIf="responseData && !mdcScript1">
                                        <div class="script">
                                            <pre style="padding-bottom: 25px;">{{ responseData }}</pre>
                                        </div>
                                    </div>
                        
                                    <div class="no-script" *ngIf="!responseData && !mdcScript1">
                                        <span>SCRIPT NOT AVAILABLE</span>
                                    </div>
                                </ng-template>

                                <ng-template #basicPreviewTemplate>
                                    <div class="script">
                                        <div *ngIf="(previewResponse$ | async) as response">
                                            <pre>{{ response }}</pre>
                                        </div>
                                    </div>
                                </ng-template>

                        
                                <div *ngIf="showScript=='show_script'">
                                    <ng-container *ngTemplateOutlet="scriptTemplate"></ng-container>
                                </div>
                        
                                <div *ngIf="showScript =='update_script'">
                                    <ng-container *ngTemplateOutlet="updateTemplate"></ng-container>
                                </div>

                                <div *ngIf="showScript =='update_script_MDC'">
                                    <ng-container *ngTemplateOutlet="updateTemplateMDC"></ng-container>
                                </div>
                        
                                <div *ngIf="showScript =='preview_script'">
                                    <ng-container *ngTemplateOutlet="previewTemplate"></ng-container>
                                </div>

                                <div *ngIf="showScript =='preview_script_MDC'">
                                    <ng-container *ngTemplateOutlet="previewMDCTemplate"></ng-container>
                                </div>

                                <div *ngIf="showScript=='show_basicScript'">
                                    <ng-container *ngTemplateOutlet="basicScriptTemplate"></ng-container>
                                </div>

                                <mat-radio-group [(ngModel)]="selectedScript1" aria-label="Select an option" *ngIf="showScript=='show_script' && editSolarScript && (this.devicetype == 'X310' || this.devicetype == 'X410')" class="margin-left-40">
                                    <mat-radio-button value="1">Install Basic Script</mat-radio-button>
                                    <mat-radio-button value="2" class="margin-left-20">Install Solar Script</mat-radio-button>
                                </mat-radio-group>
                                <div *ngIf="showScript =='preview_script' && selectedScript1=='2' && basicCheck()" class="text-center">
                                <mat-checkbox style=" display: block;"
                                    [class.custom-checked]="isChecked" 
                                    (change)="checkboxToggledBasic($event);" 
                                    [(ngModel)]="isCheckedDelay"
                                    >
                                    ADD 2 HOUR DELAY
                                </mat-checkbox>
                                <span class="note"><b>* NOTE : </b>When 2 hour delay check box is checked, device will be ON for 2 hours after the power is restored and then solar script schedule is followed.</span>
                                </div>
                                <div class="btn-container">
                                    <button class="generate" (click)="generateScript()" *ngIf="(showScript=='show_script' && editSolarScript && !responseData && (this.devicetype == 'X310' || this.devicetype == 'X410'))" mat-raised-button color="primary" class="margin-left-45 mdxGenerate" [disabled]="!selectedScript1" [style.background-color]="selectedScript1 ? '#294058' : 'grey'">GENERATE</button>
                                    <button class="generate" (click)="updateMDC()" *ngIf="(showScript=='show_script' && editSolarScript && !mdcScript1 && this.devicetype == 'Odroid')" mat-raised-button color="primary" class="margin-left-45 mdcGenerate">GENERATE</button>
                                    <button class="update mg-bm" (click)="mainUpdate()" *ngIf="(this.devicetype == 'X310' || this.devicetype == 'X410') && (showScript=='show_script' && editSolarScript && responseData)" mat-raised-button color="primary" [disabled]="!selectedScript1">UPDATE</button>
                                    <button class="update mg-bm" (click)="updateMDC()" mat-raised-button color="primary" *ngIf="showScript=='show_script' && editSolarScript && mdcScript1 && this.devicetype == 'Odroid'">UPDATE</button>
                                    <button class="cancel" (click)="cancel()" *ngIf="showScript =='update_script' || showScript =='update_script_MDC' ||  showScript =='preview_script' || showScript =='preview_script_MDC'" mat-raised-button color="warn">CANCEL</button>
                                    <button class="preview-button" (click)="handleButtonClick()" *ngIf="showScript =='update_script' && (this.devicetype == 'X310' || this.devicetype == 'X410')" mat-raised-button color="primary" [disabled]="!preStartTime || !preEndTime || !precheckDay">PREVIEW</button>
                                    <button class="preview-button" (click)="previewMDC()" *ngIf="showScript =='update_script_MDC'" mat-raised-button color="primary">PREVIEW</button>
                                    <button class="upload" (click)="uploadScript()" *ngIf="showScript =='preview_script' || showScript =='preview_script_MDC'" mat-raised-button color="primary">UPLOAD</button>
                                </div>
                            </mat-tab>
                            <mat-tab label="Solar Script History" (click)="selectTab(2)" class="script-history">
                                <div class="w-100 t-history" class="padding-btm-20">
                                    <table class="table" style="width: 100%;">
                                        <thead>
                                            <tr>
                                                <th class="sticky-header text-center">Potential ID</th>
                                                <th class="sticky-header text-center">Device Type</th>
                                                <th class="sticky-header text-center">Last Modified By</th>
                                                <th class="sticky-header text-center">Last Modified Date (UTC)</th>
                                                <th class="sticky-header text-center" class="width-130">Modified Script</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let history of scripthistory">
                                                <td class="text-center">{{history.potentialId}}</td>
                                                <td class="text-center">{{history.deviceType}}</td>
                                                <td class="text-center">{{history.lastModifiedBy}}</td>
                                                <td class="text-center">
                                                    <span [ngStyle]="{ 'margin-right': '10px' }">{{ formatdate(history.lastModifiedDate) }}</span>
                                                </td>
                                                
                                                <td class="text-center">
                                                    <span (click)="viewScript(history.script)" class="viewScript">
                                                        <img src="../../../assets/imgs/view_script.png" class="viewScriptImg">
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div *ngIf="!scripthistory || scripthistory==''" class="noData">
                                        <b>NO DATA AVAILABLE</b>
                                    </div>        
                                    <app-view-script *ngIf="isModalOpen" [scriptResponse]="selectedScript"
                                        (closeModal)="onCloseModal()"></app-view-script>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-tab>
                </mat-tab-group>

                
            </div>
        </div>
    </article>
</section>
<footer class="footer_style" style="margin-top: calc(100vh - 41%) !important">
    <app-footer></app-footer>
</footer>

<div class="modal" [class.show]="show" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" style="z-index: 9999 !important;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{camName}}</h5>
                <button type="button" class="btn btn-warning" data-dismiss="modal"
                    style="font-size: 15px;padding-top: 2px; padding-bottom: 2px">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <div style="display: flex;">
                        <div class="wd_100" style="margin-right:5px">
                            <h6>Day Image</h6><img class="img-responsive wd_100 cam_img" [src]="masking_cameradayImg"
                                alt="">
                        </div>
                        <div class="wd_100">
                            <h6> Night Image</h6><img style="float: right;" class="img-responsive wd_100 cam_img"
                                [src]="masking_nightimage" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mainbox1 cameraModel" id="modelCam">
    <div class="model_sub_box1 cam-width">
        <div (click)="closeCameraPopup()" class="close_1_button">
            <button type="button" class="close camBtn">&times;</button>
        </div>
        <app-camera-meta-data [cameraMetadata]="cameraMeta"></app-camera-meta-data>
    </div>
</div>

<div class="mainbox1 cameraModel" id="modelMdc">
    <div class="model_sub_box1 cam-width">
        <div (click)="closeMdcdata()" class="close_1_button">
            <button type="button" class="close camBtn">&times;</button>
        </div>
        <app-mdc-data [mdcData]="mdcMetadata"></app-mdc-data>
    </div>
</div>

<div class="mainbox1 cameraModel" id="modelRouter">
    <div class="model_sub_box1 cam-width">
        <div (click)="closeRouterInfo()" class="close_1_button">
            <button type="button" class="close camBtn" style="line-height: 20px;">&times;</button>
        </div>
        <app-router-info [routerData]="routerInfo"></app-router-info>
    </div>
</div>